<template>
    <div id="submit">
        <div class="row align-space-between">
            <div
                class="row align-center"
                style="gap: 12px"
                @click="
                    loadDetail();
                    showDetail = !showDetail;
                "
            >
                <p style="font-size: 28px; font-weight: bold">{{ title }}</p>
                <div
                    v-show="status != ''"
                    class="align-center"
                    style="
                        height: 28px;
                        border: 1px solid #cecece;
                        padding: 2px 16px;
                        border-radius: 20px;
                    "
                >
                    <p style="font-size: 12px">
                        {{ status }}
                    </p>
                </div>
            </div>

            <div class="row" style="gap: 12px">
                <text-button
                    :textSize="14"
                    :buttonName="'변경'"
                    :buttonStyle="{
                        border: '1px solid #CECECE',
                        padding: '4px 16px',
                        background: 'white',
                    }"
                    :textColor="status != '취소' ? 'black' : 'gray'"
                    :style="{
                        cursor: status == '취소' ? 'default' : 'pointer',
                    }"
                    @click="openPinModal(0)"
                ></text-button>

                <text-button
                    :textSize="14"
                    :buttonName="'취소'"
                    :buttonStyle="{
                        border: '1px solid #CECECE',
                        padding: '4px 16px',
                        background: 'white',
                    }"
                    :textColor="status != '취소' ? 'red' : 'gray'"
                    :style="{
                        cursor: status == '취소' ? 'default' : 'pointer',
                    }"
                    @click="openPinModal(1)"
                ></text-button>
            </div>
        </div>
        <div class="row align-space-between" style="margin-top: 16px">
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ category }}
            </p>
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ date }}
            </p>
        </div>
        <div v-show="showDetail" class="detail">
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold">고장 유형</p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px">{{ defect_type }}</p>
            </div>
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold; width: auto">
                    접수내용
                </p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p v-html="content" style="font-size: 16px; width: 90%"></p>
            </div>
            <div v-if="adminComment" style="margin-top: 12px; border-top: 1px solid #d9d9d9; padding-top: 12px">
                <div class="row" style="gap: 16px">
                    <p style="font-size: 16px; font-weight: bold; color: #00a7e7; white-space: nowrap">
                        관리자 답변
                    </p>
                    <p style="font-size: 16px; font-weight: bold">:</p>
                    <p v-html="adminCommentHtml" style="font-size: 16px; width: 90%"></p>
                </div>
            </div>
        </div>
        <PinModal
            ref="pinModal"
            :target="0"
            :targetId="classId"
            @pinVerified="handlePinVerified"
        />
    </div>
    <!-- PIN 입력 모달 -->
</template>

<script>
import { defineComponent, ref, onMounted, onUpdated } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import TextButton from "./TextButton.vue";
import PinModal from "@/components/PinModal.vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        status: {
            type: String,
            default: "",
        },
        classId: {
            type: Number,
            default: 0,
        },
        phone_number: {
            type: String,
            default: "",
        },
        userId: {
            type:Number,
            default: null
        },

        onClick: Function,
    },
    components: {
        TextButton,
        PinModal,
    },
    setup(props, { emit }) {
        const isCheck = ref(false);
        const store = useStore();
        const router = useRouter();
        const detail = ref(null);
        const content = ref("");
        const defect_type = ref("");
        const adminComment = ref("");
        const adminCommentHtml = ref("");
        const isLoad = ref(false);

        onMounted(() => {
            isCheck.value = props.checked;
        });

        onUpdated(() => {
            isCheck.value = props.checked;
        });

        const selectClass = () => {
            emit("checked", props.classId);
        };

        const showDetail = ref(false);

        const moveDetailPage = async () => {
            store.commit("setAfterserviceId", props.classId);
            router.push({
                name: `Afterservice`,
            });
        };

        const loadDetail = async () => {
            if (isLoad.value) {
                return ;
            }
            detail.value = await store.dispatch(
                "getAfterservice",
                props.classId
            );
            content.value = detail.value.detail_issue.replace(/\n/g, "<br>");
            defect_type.value = detail.value.defect_type;
            adminComment.value = detail.value.admin_comment || "";
            adminCommentHtml.value = adminComment.value.replace(/\n/g, "<br>");
            isLoad.value = true;
        };
        const pinModal = ref(null);
        const actionType = ref(null);
        //actionType: 0 => 편집
        //actionType: 1 => 삭제
        const openPinModal = (type) => {
            actionType.value = type;
            pinModal.value.openModal();
        };

        const handlePinVerified = (isAuth) => {
            if (isAuth) {
                if (actionType.value === 0) {
                    moveDetailPage();
                } else if (actionType.value === 1) {
                    store.dispatch("deleteAfterservice", {
                        id: props.classId,
                        param: {
                            userId: props.userId,
                            phone_number: props.phone_number,
                            page: 0,
                            take: 10,
                        },
                    });
                    alert("삭제되었습니다");
                    showDetail.value = false;
                    isLoad.value = false;
                }
            }
        };

        return {
            isCheck,
            selectClass,
            showDetail,
            moveDetailPage,
            loadDetail,
            content,
            defect_type,
            adminComment,
            adminCommentHtml,
            pinModal,
            openPinModal,
            handlePinVerified,
        };
    },
});
</script>

<style scoped>
button {
    padding: 8px 16px;
    border: 0.5px solid black;
    border-radius: 20px;
}

#submit {
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid #b3b3b3;
    /* cursor: pointer; */
}

.detail {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}
</style>
